import { isFunction } from '../helpers/miscellaneous'

let DELAY = 2 //ms
const MAX_DELAY = 120000 // 2 mins

export const onConnect = (socket, callback) => {
    if (!socket || !isFunction(callback)) return

    if (socket.readyState === 1) {
        callback()
    } else {
        DELAY = Math.min(DELAY * 2, MAX_DELAY)

        if (DELAY === MAX_DELAY) return

        setTimeout(() => {
            onConnect(socket, callback)
        }, DELAY)
    }
}
